import { FC } from "react";
import {
  PrimaryButton,
  SecondaryButton,
  TertiaryButton,
  RoundedButton,
  UnderlineButton,
  TransparentButton,
  Flex,
} from "flicket-ui";

export interface IOfferingAction {
  variant:
    | "primary"
    | "secondary"
    | "tertiary"
    | "rounded"
    | "underline"
    | "transparent";
  label: string;
  href?: string;
  onClick?: (...args: unknown[]) => void;
}

export interface OfferingCallToActionProps {
  actions: IOfferingAction[];
}

export const OfferingCallToAction: FC<OfferingCallToActionProps> = ({
  actions,
}) => {
  return (
    actions.length > 0 && (
      <Flex
        flexDirection={{
          base: "column-reverse",
          sm: "row",
          md: "column-reverse",
        }}
        justifyContent="center"
        minW={{ base: "100%", md: "390px" }}
        px={2}
        py={{ _: 1, sm: 2, md: 1 }}
        boxShadow="card"
        borderRadius={{ _: "none", md: "md" }}
        position={{ base: "fixed", md: "static" }}
        bottom={{ base: 0, md: "auto" }}
        left={{ base: 0, md: "auto" }}
        right={{ base: 0, md: "auto" }}
        bg="white"
        zIndex={10}
      >
        {actions
          .map((action, index) => {
            // TODO: switch to use Button variants when available
            let Button = SecondaryButton;
            switch (action.variant) {
              case "primary":
                Button = PrimaryButton;
                break;
              case "secondary":
                Button = SecondaryButton;
                break;
              case "tertiary":
                Button = TertiaryButton;
                break;
              case "rounded":
                Button = RoundedButton;
                break;
              case "underline":
                Button = UnderlineButton;
                break;
              case "transparent":
                Button = TransparentButton;
                break;
              default:
                Button = SecondaryButton;
                break;
            }
            return (
              <Button
                key={`offering-cta-btn-${index}`}
                to={action.href}
                onClick={action.onClick}
                my={{ _: 1, sm: 0, md: 1 }}
                mx={{ _: 0, sm: 1, md: 0 }}
                flex={{ sm: 1, md: "initial" }}
                w={{ _: "100%", md: "auto" }}
              >
                {action.label}
              </Button>
            );
          })
          .reverse()}
      </Flex>
    )
  );
};
